angular.module('impactx.approval').controller('ContractChangeDialogCtrl', ContractChangeDialogCtrl);

ContractChangeDialogCtrl.$inject = ['$scope', 'dataGen', 'BackService', 'ToastService', '$routeParams', 'TranslationService',
    'ToolbarService', '$redirect', '$mdDialog', 'OutsourcedCommentSaveService', 'ProductSelectionService'];

function ContractChangeDialogCtrl($scope, dataGen, BackService, ToastService, $routeParams, TranslationService, ToolbarService,
                                  $redirect, $mdDialog, OutsourcedCommentSaveService, ProductSelectionService) {
    var init = true;
    var ctrl = this;

    var atiId = $routeParams.atiId;
    var itemId = 0;
    var headerTable = 'PRH';
    var entryPointGet = "/approval/contractchange/edit";
    var entryPointSave = "/approval/saveitem";

    ctrl.getData = function () {
        dataGen.getData({}, {atiId: atiId}, '/approval/contractchange/view').then(function (data) {
            if (data && data.data) {
                itemId = data.data.priId;
                if (data.data.isPriFreeform) {
                    entryPointGet = "/approval/contractchange/editfreeform";
                    entryPointSave = "/approval/savefreeformitem";
                }
                var paramObj = {
                    id: itemId,
                    headerId: data.data.prhId,
                    productId: data.data.proId
                };
                dataGen.getData($scope, paramObj, entryPointGet).then(function () {
                    angular.extend($scope, data.data);
                    angular.extend($scope.trns, data.trns);
                    handleData();
                    defineButtons();
                });
            }
        });
    };

    ctrl.showProcessData = function () {
        return $scope.data.requestItem.foreignOrderData || $scope.data.requestItem.sapData || $scope.data.requestItem.processAttributes;
    }

    ctrl.showExternalComments = function () {
        return !$scope.hideExternalComments && $scope.data.requestItem.comments.externalComments &&
        ($scope.data.requestItem.comments.externalComments.comments.length > 0 || !$scope.data.requestItem.comments.externalComments.readOnly)
    }

    ctrl.save = function () {
        return saveInternal(function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            BackService.back();
        });
    };

    ctrl.saveAndRecalc = function () {
        return saveInternal(function () {
            var params = {
                atiId: atiId,
                priId: itemId
            };
            dataGen.postAsForm({}, params, '/approval/reevaluate').then(function (data) {
                ToastService.openStandardToast(data.trns.restartSuccess);
                BackService.back();
            });
        });
    }

    ctrl.cancelPRI = function (event) {
        return $mdDialog.show({
            controller: 'ContractChangeCancelCtrl',
            controllerAs: 'contractChangeCancelCtrl',
            templateUrl: 'modules/approval/templates/contractchange-cancel.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            fullscreen: true,
            bindToController: true,
            locals: {
                title: $scope.trns.cancellation,
                cancelReason: $scope.cancelReason,
                cancelLabel: $scope.trns.cancellation,
                commentLabel: $scope.trns.approvalComments,
                approvalComments: impactX.isDefined($scope, 'data.requestItem.comments.approvalComments')
                }
            }).then(function (result) {
            var params = {
                atiId: atiId,
                priId: itemId,
                reason: result.reason,
                comment: result.comment
            };
            return dataGen.postAsForm({}, params, "/approval/contractchange/cancel").then(function () {
                ToastService.openStandardToast($scope.trns.cancelSuccess);
                BackService.back();
            });
        })
    };

    ctrl.replaceProduct = function () {
        var contextUsrId = $scope.replaceContextUSRId;
        var config = {
            title: $scope.trns.replaceProduct,
            locals: {
                ctxUsrId: contextUsrId
            }
        };
        return ProductSelectionService.open(config).then(function(selectedProduct) {
            if (selectedProduct) {
                return dataGen.postAsForm($scope, {
                    proId: selectedProduct.id,
                    priId: $scope.priId
                }, "/approval/replaceproduct").then(function() {
                    ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                    BackService.back();
                });
            }
        });
    };

    ctrl.createNewRFQH = function (event) {
        return saveInternal(function () {
            var paramObj = {
                type: "all",
                id: 0
            };
            dataGen.postAsForm({}, paramObj, '/rfx/rfqc/select').then(function (data) {
                if (data) {
                    if (impactX.isDefined(data, 'data.rfqc.selected.id')) {
                        addToOrCreateRFX(0, data.data.rfqc.selected.id);
                    }
                    else if (data.data) {
                        $mdDialog.show({
                            controller: 'RFQCSelectionCtrl',
                            controllerAs: 'rfqcSelectionCtrl',
                            templateUrl: 'modules/rfx/templates/rfqcselection.tmpl.html',
                            parent: angular.element(document.body),
                            targetEvent: event,
                            clickOutsideToClose: false,
                            bindToController: true,
                            locals: {
                                data: data,
                                type: "all",
                                id: 0
                            }
                        }).then(function (rfqcId) {
                            addToOrCreateRFX(0, rfqcId);
                        })
                    }
                }
            });
        })
    };

    ctrl.addToRFQH = function (event) {
        return saveInternal(function () {
            $mdDialog.show({
                controller: 'ContractChangeAddToRFQHCtrl',
                controllerAs: 'contractChangeAddToRFQHCtrl',
                bindToController: true,
                templateUrl: 'modules/approval/templates/contractchange-addtorfqh.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    preparedRFQH: $scope.preparedRFQH,
                    title: $scope.trns.addToRFQ,
                    saveLabel: $scope.trns.addToRFQ
                }
            }).then(function (rfqhId) {
                addToOrCreateRFX(rfqhId, 0);
            })
        });
    };

    ctrl.redirectToExistingRFQH = function () {
        redirectToRFX($scope.rfqhId);
    }

    ctrl.showAccounting = function () {
        if ((!$scope.data.requestItem.isFreeform || impactX.isDefined($scope, 'data.requestItem.contract.selected.id')) && !$scope.hideOrderData) {
            var ctrl = $scope.data.requestItem.control;
            return showOneControl(ctrl.ctu) ||
                showOneControl(ctrl.ctt) ||
                showOneControl(ctrl.prj) ||
                showOneControl(ctrl.ctrlA) ||
                showOneControl(ctrl.ctrlB) ||
                showOneControl(ctrl.ctrlC) ||
                showOneControl(ctrl.ctrlD) ||
                showOneControl(ctrl.crd) ||
                showOneControl(ctrl.psp) ||
                showOneControl(ctrl.asn) ||
                showOneControl(ctrl.ino) ||
                showOneControl(ctrl.loc) ||
                showOneControl(ctrl.eko) ||
                showOneControl(ctrl.ekg)||
                showOneControl(ctrl.act)||
                showOneControl(ctrl.net);
        }
        return false;
    };

    ctrl.changeAat = function (aatId, itemId) {
        dataGen.postAsForm({}, {aatId: aatId, itemId: itemId}, "/approval/changeaatdetail").then(function (result) {
            if (result && result.data) {
                $scope.data.requestItem.control = result.data;
            }
        });
    };

    $scope.onContractSelect = function (selected) {
        if(selected && ($scope.oldContractSelected != selected.id)) {
            $scope.contractRequestInProgress = true;
            var tempScope = {};
            dataGen.getData(tempScope, {
                cscId: selected.id,
                headerId: $scope.data.requestItem.headerId,
                itemId: itemId,
                headerTable: headerTable,
                prgId: $scope.data.requestItem.productGroup.selected.id
            }, "/basket/contract/updatedata").then(function() {
                if ($scope.data.requestItem.productGroup) {
                    $scope.data.requestItem.productGroup.entries = tempScope.data.prg.entries;
                    $scope.data.requestItem.productGroup.showMust = tempScope.data.prg.showMust;
                }
                if ($scope.data.requestItem.purchaserGroups) {
                    $scope.data.requestItem.purchaserGroups.entries = tempScope.data.pug.entries;
                    $scope.data.requestItem.purchaserGroups.showMust = tempScope.data.pug.showMust;
                }
                $scope.data.requestItem.isBANF = tempScope.data.isBANFContract;
                $scope.data.requestItem.deliveryDate.showMust = tempScope.data.deliveryDateRequired;
                $scope.data.requestItem.price.netValue.showMust = !tempScope.data.zeroPrice;
                $scope.data.requestItem.price.netValue.allowNegative = tempScope.data.negativePrice;
                $scope.data.requestItem.amount.noDigits = tempScope.data.noDigits;
                if ($scope.data.requestItem.eClassSelection) {
                    $scope.data.requestItem.eClassSelection.showMust = tempScope.data.eClassMandatory;
                }

                if (tempScope.data.foreignOrderData) {
                    $scope.data.requestItem.foreignOrderData = tempScope.data.foreignOrderData;
                }

                if (tempScope.data.preSetEClass) {
                    if (!$scope.data.requestItem.eClassSelection.selected) {
                        $scope.data.requestItem.eClassSelection.selected = tempScope.data.preSetEClass
                    }
                }

                $scope.data.requestItem.isCPDContract = tempScope.data.isCPDContract;
                if ($scope.data.requestItem.isCPDContract && !$scope.data.requestItem.cpdAddress) {
                    $scope.data.requestItem.cpdAddress = tempScope.data.cpdAddress;
                    $scope.trns.requiredError = TranslationService.get("required");
                    $scope.trns.requiredError = TranslationService.get("required");
                }
                // remove inv addresses if fixed but keep it in background, since user can change the contract
                if(tempScope.data.invoiceAdrFixed) {
                    $scope.invoiceAdr = $scope.data.requestItem.invoiceAddresses;
                    $scope.data.requestItem.invoiceAddresses = null;
                } else if($scope.invoiceAdr && !$scope.data.requestItem.invoiceAddresses) {
                    $scope.data.requestItem.invoiceAddresses = $scope.invoiceAdr;
                    $scope.invoiceAdr = null;
                }

                if (tempScope.data.isBANFContract) {

                    $scope.showDeliveryDateGeneral = true;
                    var entrys = $.grep($scope.data.requestItem.price.currency.entries, function (entry) {
                        return entry.id == tempScope.data.contractCurrency;
                    });

                    if (entrys.length > 0) {
                        $scope.data.requestItem.price.currency.selected = entrys[0];
                    }

                    $scope.data.requestItem.price.currency.readOnly = true;

                    if(!tempScope.data.comments) {
                        $scope.hideExternalComments = true;
                    }
                }
                else {
                    $scope.showDeliveryDateGeneral = false;
                    $scope.hideExternalComments = false;
                }

                if ($scope.data.requestItem.comments && tempScope.data.comments) {
                    $scope.data.requestItem.comments.externalComments.attachmentRequired = tempScope.data.comments.externalComments.attachmentRequired;
                    $scope.data.requestItem.comments.externalComments.inputTranslation = tempScope.data.comments.externalComments.inputTranslation;
                    $scope.data.requestItem.comments.externalComments.attachmentsAllowed = tempScope.data.comments.externalComments.attachmentsAllowed;
                    $scope.data.requestItem.comments.externalComments.readOnly = tempScope.data.comments.externalComments.readOnly;
                    if(tempScope.data.comments.externalComments.attachmentRequired && tempScope.data.comments.externalComments.attachmentRequired.value) {
                        angular.forEach($scope.data.requestItem.comments.externalComments.newComments, function(comment) {
                            if(comment.attachments && (comment.attachments.newEntries.length > 0 || comment.attachments.existingEntries.length > 0)) {
                                $scope.data.requestItem.comments.externalComments.attachmentRequired.value = false;
                            }
                        });
                        angular.forEach($scope.data.requestItem.comments.externalComments.comments, function(comment) {
                            if(comment.attachments && (comment.attachments.existingEntries.length > 0 || comment.attachments.existingEntries.length > 0)) {
                                $scope.data.requestItem.comments.externalComments.attachmentRequired.value = false;
                            }
                        });
                    }
                }
                init = false;
            }).finally(function () {
                $scope.contractRequestInProgress = false;
            });
            $scope.oldContractSelected = selected.id;
        }
        else {
            if(!selected) {
                if($scope.data.requestItem.productGroup.entries) {
                    $scope.data.requestItem.productGroup.entries.length = 0;
                    $scope.data.requestItem.productGroup.selected = {};
                }
                $scope.oldContractSelected = 0;
                $scope.data.requestItem.price.netValue.showMust = true;
            }
        }
    };

    ctrl.updateMaterialGroupMapping = function (selected) {
        $scope.eClassDataArray = [{field: "eClass", value: selected ? selected.value : null},
            {field: "sapConfigId", value: $scope.data.requestItem.sapConfigId}];

        if ($scope.data.requestItem.eClassMaterialGroupMapping) {
            if (!selected) {
                $scope.data.requestItem.eClassMaterialGroupMapping.selected = null;
            }
            else {
                var tempScope = {};
                dataGen.getData(tempScope, {
                    eClass: selected.secondValue,
                    sapConfigId: $scope.data.requestItem.sapConfigId
                }, "/basket/freeform/materialgroupmappingforeclass").then(function() {
                    $scope.data.requestItem.eClassMaterialGroupMapping.selected = tempScope.data.newMapping;
                });
            }
        }
    };

    ctrl.getData();

    function saveInternal(postSaveFunc) {
        var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data.requestItem);

        var dataObj = {
            data: $scope.data
        };
        return dataGen.post({}, dataObj, entryPointSave).then(function (commentData) {
            if (commentData && commentData.data) {
                OutsourcedCommentSaveService.saveComments(commentData.data, extractedComments).then(postSaveFunc, postSaveFunc);
            }
            else {
                postSaveFunc();
            }
        }, function () {
            OutsourcedCommentSaveService.restoreComments($scope.data.requestItem, extractedComments);
        });
    }

    function redirectToRFX(rfqhId) {
        $redirect.redirectTo(null, '/rfxbuyer/' + rfqhId)
    }

    function addToOrCreateRFX(rfqhId, rfqcId) {
        var params = {
            priId: itemId,
            rfqhId: rfqhId,
            rfqcId: rfqcId
        }
        dataGen.postAsForm({}, params, '/approval/contractchange/addtorfx').then(function (data) {
            if (data && data.data && data.data.rfqhId) {
                redirectToRFX(data.data.rfqhId)
            }
        });
    }

    function showOneControl(control) {
        return control && (control.set.length > 0 || !control.readOnly);
    }

    function handleData() {
        $scope.eClassDataArray = [{field: "eClass", value: $scope.data.requestItem.eClass},
            {field: "sapConfigId", value: $scope.data.requestItem.sapConfigId}];

        handleControlDataForChips($scope.data.requestItem.control);
        if ($scope.data.requestItem.comments) {
            if ($scope.data.requestItem.comments.internalComments) {
                $scope.data.requestItem.comments.internalComments.newComments = [];
            }
            if ($scope.data.requestItem.comments.externalComments) {
                $scope.data.requestItem.comments.externalComments.newComments = [];
            }
        }
        if ($scope.data.requestItem.contract) {
            if ($scope.data.requestItem.contract.selected && ctrl.onContractSelect) {
                ctrl.onContractSelect($scope.data.requestItem.contract.selected);
            }
        }

        var scrollList = [];
        scrollList.push({id: "general", label: $scope.trns.general});
        if ($scope.data.requestItem.isCPDContract) {
            scrollList.push({id: "cpdAddress", label: $scope.data.requestItem.cpdAddress.labelAddress});
        }
        scrollList.push({id: "moreDetails", label: $scope.trns.details});
        scrollList.push({id: "address", label: $scope.trns.address});
        if (ctrl.showAccounting()) {
            scrollList.push({id: "control", label: $scope.trns.control});
        }
        scrollList.push({id: "internalcomments", label: $scope.trns.internalComments});
        if (ctrl.showExternalComments()) {
            scrollList.push({id: "externalcomments", label: $scope.trns.externalComments});
        }
        if (ctrl.showProcessData()) {
            scrollList.push({id: "process", label: $scope.trns.process});
        }
        if ($scope.data.requestItem.hasAttributes) {
            scrollList.push({id: "attributes", label: $scope.trns.attributes});
        }
        ToolbarService.setScrollMenu(scrollList);
    }

    function canSave() {
        return $scope.allowSave && !existsRFQH();
    }

    function canSaveAndRecalc() {
        return $scope.allowRestartByApprover;
    }

    function canCancelPRI() {
        return $scope.allowCancellation;
    }

    function canReplaceProduct() {
        return $scope.allowReplace && !existsRFQH();
    }

    function canStartNewRFQH() {
        return $scope.allowRFQ && !existsRFQH();
    }

    function canAddToRFQH() {
        return $scope.allowAddToRFQ && !existsRFQH();
    }

    function existsRFQH() {
        return !!$scope.rfqhId;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                // save
                label: $scope.trns.save,
                type: 'validation',
                action: ctrl.save,
                condition: canSave,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                // save and recalc
                label: $scope.trns.saveAndRecalc,
                type: 'validation',
                action: ctrl.saveAndRecalc,
                condition: canSaveAndRecalc,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                // pro replace
                label: $scope.trns.replaceProduct,
                type: 'dialogaction',
                action: ctrl.replaceProduct,
                condition: canReplaceProduct
            },
            {
                // new rfqh
                label: $scope.trns.startRFQ,
                type: 'dialogaction',
                action: ctrl.createNewRFQH,
                condition: canStartNewRFQH
            },
            {
                // add to rfqh
                label: $scope.trns.addToRFQ,
                type: 'dialogaction',
                action: ctrl.addToRFQH,
                condition: canAddToRFQH
            },
            {
                // redirect to existing
                label: $scope.trns.redirectToRFQ,
                type: 'dialogaction',
                action: ctrl.redirectToExistingRFQH,
                condition: existsRFQH
            },
            {
                // deny/cancel
                label: $scope.trns.cancellation,
                type: 'dialogaction',
                action: ctrl.cancelPRI,
                condition: canCancelPRI
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}